'use strict';
module.exports = function Viewport(domElement, scrollAnimator) {
	let cachedDimensions, currentAnimation;
	const self = this,
		dropCache = () => cachedDimensions = false;

	// required so DOM can focus on it
	domElement.setAttribute('tabindex', '1');
	domElement.style.overflow = 'auto';

	self.getDimensions = function () {
		if (cachedDimensions) {
			return cachedDimensions;
		}
		cachedDimensions =  {
			left: domElement.scrollLeft,
			top: domElement.scrollTop,
			width: domElement.clientWidth,
			height: domElement.clientHeight
		};
		return cachedDimensions;
	};
	self.getCenter = function () {
		return {
			x: Math.round(domElement.clientWidth / 2),
			y: Math.round(domElement.clientHeight / 2)
		};
	};
	self.dropCache = dropCache;
	domElement.addEventListener('scroll', dropCache);
	self.coordinatesForPointEvent = function (evt) {
		const boundingRect = domElement.getBoundingClientRect();
		if (Number.isFinite(evt.clientX) && Number.isFinite(evt.clientY)) {
			const result = {
				x: evt.clientX - boundingRect.left,
				y: evt.clientY - boundingRect.top
			};
			if (result.x >= 0 && result.x <= boundingRect.width && result.y >= 0 && result.y <= boundingRect.height) {
				return result;
			}
		}
	};
	self.focus = () => domElement.focus();
	self.finishScrolling = () => {
		if (currentAnimation) {
			currentAnimation.finish();
		}
		dropCache();
	};
	self.setPosition = (x, y, animate) => {
		if (currentAnimation) {
			currentAnimation.finish();
			currentAnimation = false;
		}
		if (animate) {
			currentAnimation = scrollAnimator.animate(domElement, {left: x, top: y, duration: 200});
		} else {
			domElement.scrollLeft = x;
			domElement.scrollTop = y;
		}
	};
};
